var viewportMobile = 767;

$(function() {

	$("#burgerMenu").click(function() {
		$(this).toggleClass('open');
		$('#leftBar').toggleClass('show');
	});

	if ($(window).width() <= viewportMobile) {
		calculMenuPosition();
	}

	$(window).resize(function() {

		if ($(window).width() <= viewportMobile) {
			calculMenuPosition();
			if ($('#searchCarousel').find('.slick-track').length > 0) {
				$('#searchCarousel').slick('unslick');
			}
		}
		else {
			if ($('#searchCarousel').find('.slick-track').length == 0 && $('#searchCarousel').is(':visible')) {
				initSearchCarousel();
			}
			resetMenuPosition();
		}

	});

	// Script Open Search Function
	$("#menuInput").click(function(e) {

		if ($(window).width() <= viewportMobile) {

			if (!$(event.target).closest('#menuCursor').length) {
				return false;
			}
		}

	    var speed = 400;
	    $(".dropDown").stop().slideUp(speed);

	    if ($('#menuInput').hasClass('open')) {
			$("#searchView").stop().slideToggle(speed, function() {
		    	$('#menuInput').removeClass('open');
		    	if ($('#searchCarousel').find('.slick-track').length > 0) {
		    		$('#searchCarousel').slick('unslick');
		    	}
		    });
		}
		else {
			$('#menuInput').addClass('open');
			$("#searchView").stop().slideDown(speed);
		}

	    // Init carousel when open search bloc
	    if ($('#searchCarousel').find('.slick-track').length == 0 && $(window).width() > viewportMobile) {
	    	initSearchCarousel();
	    }
	});

    $('#ui-search-carousel-next').click(function() {
		$('#searchCarousel .slick-next').click();
		return false;
	});

	// Script Close Search Function
	$("#closeSearch").click(function() {

	    var speed = 400;

	    if ($('#menuInput').hasClass('open')) {
			$("#searchView").stop().slideToggle(speed, function() {
		    	$('#menuInput').removeClass('open');
		    });
		}
		else {
			$('#menuInput').addClass('open');
			$("#searchView").stop().slideDown(speed);
		}
	});

	$(".blocPopup .close").click(function() {
		$(".blocPopup:visible").slideUp(400);
	});

	// Script Popup Bottom
	$(".imgFooter img").click(function() {
	    var speed = 400;
	    var speedOut = 200;
	    if ($(this).attr("class") != "noPopup"){
	    	if ($(this).attr("id") == "imgCopyright") {
	            $(".blocPopup").not("#popupCopyright").slideUp(speedOut);
	            $("#popupCopyright").slideToggle(speed);
	        }
	        else if ($(this).attr("id") == "imgSize") {

	            $(".blocPopup").not("#popupChartSize").slideUp(speedOut, function() {
	            	unslickPopup($(this));
	            });

	            $("#popupChartSize").slideToggle(speed);

	            if ($('#carouselChartSize').find('.slick-track').length == 0) {
		        	$('#carouselChartSize').slick({
				        slidesToShow: 4,
				        slidesToScroll: 1,
				    });
	        	}

	        }
	        else if ($(this).attr("id") == "imgCurrency") {
	            $(".blocPopup").not("#popupCurrency").slideUp(speedOut, function() {
	            	unslickPopup($(this));
	            });
	            $("#popupCurrency").slideToggle(speed);
	            initFooterCarousel($("#popupCurrency"));
	        }
	        else if ($(this).attr("id") == "imgLang") {
	            $(".blocPopup").not("#popupLang").slideUp(speedOut, function() {
	            	unslickPopup($(this));
	            });
	            $("#popupLang").slideToggle(speed);
	            initFooterCarousel($("#popupLang"));
	        }
	        else if ($(this).attr("id") == "imgShipPolicy") {
	            $(".blocPopup").not("#popupPolicy").slideUp(speedOut, function() {
	            	unslickPopup($(this));
	            });
	            $("#popupPolicy").slideToggle(speed);
	            initFooterCarousel($("#popupPolicy"));
	        }
	        else if ($(this).attr("id") == "imgClip") {
	            $(".blocPopup").not("#popupClip").slideUp(speedOut, function() {
	            	unslickPopup($(this));
	            });
	            $("#popupClip").slideToggle(speed);
	            initFooterCarousel($("#popupClip"));
	        }
	        else if ($(this).attr("id") == "imgNewsletter") {
	            $(".blocPopup").not("#popupNews").slideUp(speedOut);
	            $("#popupNews").slideToggle(speed);
	        }

	    }
	});

	$("#notification").click(function() {
	    var speed = 400;
	    var speedOut = 200;

        $(".blocPopup").not("#popupPurchaseStatut").slideUp(speedOut);
        $("#popupPurchaseStatut").slideToggle(speed);

	    return false;
	});


    $('#nextSize .ball').click(function() {
    	$('#carouselChartSize .slick-next').click();
		return false;
    });

    $('.blocPopupFlex .next .ball').click(function() {
    	$('.blocPopupFlex:visible').find('.slick-next').click();
    });

});

function calculMenuPosition() {

	var navHeight = $('#nav').innerHeight();
	var menuHeight = $('#menu').innerHeight();

	var calculHeight = navHeight + menuHeight;
	var leftBarHeight = $(window).height() - calculHeight;

	$('#leftBar').css({'height' : Math.round(leftBarHeight), 'top' : Math.round(calculHeight)});

}


function resetMenuPosition() {

	$('#leftBar').css({'height' : 'inherit', 'top' : 'inherit'});

}

function initSearchCarousel() {

	$('#searchCarousel').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
    });

}

function initFooterCarousel(id) {

	if (id.find('.slick-track').length == 0) {

		id.find('.carouselPopup').slick({
	        slidesToShow: 3,
	        slidesToScroll: 1,
	    });

	    id.find('.next').show();

	}

}

function unslickPopup(element) {

	if (element.find('.slick-track').length > 0) {
		element.find('.carouselPopup').slick('unslick');
	}
}
